import {
	CreateDrawerFormProps,
	FormDrawerContentProps,
	I18nFormDrawer,
	I18nFormDrawerContent,
	I18nFormFetchDrawer,
	I18nTextField,
	UpdateDrawerFormProps,
	useDynamicConfig,
	validateEachLanguage,
} from "@dgs/core";
import { FormikErrors } from "formik";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { eventCategoryService } from "../shared/api/eventCategoryService";
import { EventCategoryFormValues, EventCategoryTranslationEntry } from "../shared/types/eventCategory";

const useValidate = () => {
	const { t } = useTranslation();

	return (values: EventCategoryFormValues) => {
		const errors: Record<string, any> = {};
		return {
			...errors,
			...validateEachLanguage(values.translations, (_, translation) => {
				const errors: FormikErrors<EventCategoryTranslationEntry> = {};
				if (!translation.name) {
					errors.name = t("Required field");
				}
				return errors;
			}),
		};
	};
};

const emptyTranslation = { name: "" };

const EventCategoryFormDrawerContent: FC<FormDrawerContentProps> = (props) => {
	const { t } = useTranslation();

	return (
		<I18nFormDrawerContent {...props} emptyTranslation={emptyTranslation}>
			<I18nTextField name="name" label={t("Name")} required="onlyOnMainForm" />
		</I18nFormDrawerContent>
	);
};

export const EventCategoryCreateDrawer: FC<CreateDrawerFormProps<EventCategoryFormValues>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();
	const { languageSettings } = useDynamicConfig();

	const initialValues: EventCategoryFormValues = useMemo(
		() => ({
			translations: [{ locale: languageSettings.fallback, name: "" }],
		}),
		[languageSettings.fallback],
	);

	return (
		<I18nFormDrawer
			{...props}
			initialValues={initialValues}
			title={t("Create event category")}
			validate={validate}
			renderForm={(formProps) => <EventCategoryFormDrawerContent {...formProps} {...props} />}
		/>
	);
};

export const EventCategoryUpdateDrawer: FC<UpdateDrawerFormProps<EventCategoryFormValues>> = (props) => {
	const { t } = useTranslation();
	const validate = useValidate();

	return (
		<I18nFormFetchDrawer
			{...props}
			title={t("Edit event category")}
			queryFn={() => eventCategoryService.show(props.id).then((x) => x.data.data)}
			queryKey={eventCategoryService.showKey(props.id)}
			validate={validate}
			renderSuccess={(formProps) => <EventCategoryFormDrawerContent {...props} {...formProps} />}
		/>
	);
};
